import { useEffect, useState } from 'react';
import { DEFAULT_API_COOLDOWNS } from '../../data/Constants';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import { AttemptsTypeEnum } from '../../enums/AttemptsTypeEnum';
import { convertSecondsToMMSS } from '../../utils/GenericFunctions';
import { usePersistedState } from '../../hooks/PreserveState';

interface TimerButtonProps {
  name: string;
  isLoading: boolean;
  type: AttemptsTypeEnum;
  handleResend: () => Promise<void>;
}

export default function TimerButton({
  name,
  type,
  isLoading,
  handleResend
}: TimerButtonProps) {
  const [seconds, setSeconds] = usePersistedState(`${name}-seconds`, 0);
  const [runTime, setRunTime] = useState(false);

  const { attempts, increaseAttemptByType } = useControllerFlowStepsContext();

  useEffect(() => {
    timeOutResend(attempts?.[type]);
  }, []);

  function timeOutResend(intervalPos: number) {
    setRunTime(true);
    let initSeconds = DEFAULT_API_COOLDOWNS[intervalPos] || 60;
    setSeconds(initSeconds);
    const interval = setInterval(() => {
      if (initSeconds == 0) {
        clearInterval(interval);
        setSeconds(0);
        setRunTime(false);
      } else {
        setSeconds(--initSeconds);
      }
    }, 1000);
  }

  async function handleTryAgain() {
    if (isLoading || runTime) return;

    await handleResend();
    increaseAttemptByType(AttemptsTypeEnum?.[type]);
    timeOutResend(attempts?.[type] + 1);
  }

  return (
    <div className="mt-12">
      <p className="caption text-disabled">Precisa de um código novo?</p>
      {isLoading ? (
        <p className="caption text-disabled">Enviando outro código...</p>
      ) : seconds === 0 ? (
        <p
          className="caption hover"
          style={{
            fontWeight: 500,
            color: 'var(--Text-colors-Text-Secondary)'
          }}
          onClick={handleTryAgain}
        >
          Receber outro código
        </p>
      ) : (
        <p className="caption text-disabled" data-testid="wait-timer-container">
          Aguarde {convertSecondsToMMSS(seconds)} segundos
        </p>
      )}
    </div>
  );
}
